// @flow
import loadable from '@loadable/component'
import { memo } from 'react'
import type { WidgetNames, Widget } from './types'
import { WIDGETS } from './constants'

const Menu = loadable(() => import(/* webpackChunkName: "menu" */ './external/menu'))
const Reviews = loadable(() => import(/* webpackChunkName: "reviews" */ './external/reviews'))
const FeaturedCoaches = loadable(() => import(/* webpackChunkName: "featuredCoaches" */ './external/featured-coaches'))
const CoachEnrollment = loadable(() => import(/* webpackChunkName: "coachEnrollment" */ './external/coach-enrollment'))
const ShortForm = loadable(() => import(/* webpackChunkName: "shortForm" */ './external/short-form'))
const UserTypePrompt = loadable(() => import(/* webpackChunkName: "userTypePrompt" */ './external/user-type-prompt'))

export const COMPONENTS_MAP: $EnumMap<
  WidgetNames,
  React$AbstractComponent<Widget<{ ... }>, mixed>,
  { [WidgetNames]: React$AbstractComponent<Widget<{ ... }>, mixed> }
> = Object.freeze({
  MENU: Menu,
  REVIEWS: Reviews,
  FEATURED_COACHES: FeaturedCoaches,
  COACH_ENROLLMENT: CoachEnrollment,
  SHORT_FORM: ShortForm,
  USER_TYPE_PROMPT: UserTypePrompt,
})

type ExternalWrapperProps = {| index: number, widget: Widget<{ ... }> |}

const ExtrernalWrapper = memo<ExternalWrapperProps>(({ widget }: ExternalWrapperProps) => {
  const Component = COMPONENTS_MAP[widget.name]

  return <Component {...widget} />
})

export const WIDGETS_COMPONENTS: $EnumMap<
  WidgetNames,
  (props: ExternalWrapperProps & { index: number }) => React$Node,
  { [WidgetNames]: typeof ExtrernalWrapper }
> = Object.freeze({
  MENU: function MenuWidget({ index, widget }: ExternalWrapperProps) {
    return <ExtrernalWrapper key={`${WIDGETS.MENU}_${index}`} index={index} widget={widget} />
  },
  REVIEWS: function ReviewWidget({ index, widget }: ExternalWrapperProps) {
    return <ExtrernalWrapper key={`${WIDGETS.REVIEWS}_${index}`} index={index} widget={widget} />
  },
  FEATURED_COACHES: function FeatureCoachWidget({ index, widget }: ExternalWrapperProps) {
    return <ExtrernalWrapper key={`${WIDGETS.FEATURED_COACHES}_${index}`} index={index} widget={widget} />
  },
  COACH_ENROLLMENT: function CoachEnrollmentWidget({ index, widget }: ExternalWrapperProps) {
    return <ExtrernalWrapper key={`${WIDGETS.COACH_ENROLLMENT}_${index}`} index={index} widget={widget} />
  },
  SHORT_FORM: function ShortFormWidget({ index, widget }: ExternalWrapperProps) {
    return <ExtrernalWrapper key={`${WIDGETS.SHORT_FORM}_${index}`} index={index} widget={widget} />
  },
  USER_TYPE_PROMPT: function UserTypePromptWidget({ index, widget }: ExternalWrapperProps) {
    return <ExtrernalWrapper key={`${WIDGETS.USER_TYPE_PROMPT}_${index}`} index={index} widget={widget} />
  },
})
